import { NgModule, InjectionToken } from '@angular/core';

export let APP_CONFIG = new InjectionToken<AppConfig>('app-config');

export class AppConfig {
  // readonly froalaLicenseKey = 'iMFIZJNKLDXIREJI=='; // version < 2.8.0
  // readonly froalaLicenseKey = 'iTB2xB6C1D5D1F2B1wd1DBKSPF1WKTUCQOa1OURPJ1KDe2F-11D2C2D2H2C3B3A2D6C1A1=='; // version 3
  readonly froalaLicenseKey = 'iG2C1G2A5A3B3tA1A1A1F1H4A1D2B1C7C5oc1Pe1HTPYd1RNd1J1KDe2=='; // version >= 2.8.0

  readonly businessRules = {
    MAX_PRIORITY_COUNT: 10
  };
  readonly uiRules = {
    deliverables: {
      strategyMap: {
        MAX_COLUMNS_PER_PAGE: 3,
        MAX_PAGE_COUNT: 4
      }
    }
  };
}

export let appConfig = new AppConfig();

@NgModule({
  providers: [{
    provide: APP_CONFIG,
    useValue: appConfig
  }]
})
export class AppConfigModule {}
